// extracted by mini-css-extract-plugin
export var logo = "_cb-2";
export var logoWrapper = "_cb-1";
export var strip = "_cb-0";